module.exports = __webpack_public_path__ + "static/media/bunker.2263fae6.svg";